"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBasisTheory = useBasisTheory;
var _react = require("react");
var _BasisTheoryProvider = require("./BasisTheoryProvider");
var _BasisTheoryReact = require("./BasisTheoryReact");
// eslint-disable-next-line get-off-my-lawn/prefer-arrow-functions
function useBasisTheory(apiKey, options) {
  const [state, setState] = (0, _react.useState)({});
  const isLoading = (0, _react.useRef)(false);
  const {
    bt: btFromContext
  } = (0, _BasisTheoryProvider.useBasisTheoryFromContext)();
  (0, _react.useEffect)(() => {
    (async () => {
      if (!state.bt && apiKey && !state.error && !isLoading.current) {
        try {
          isLoading.current = true;
          const bt = await new _BasisTheoryReact.BasisTheoryReact().init(apiKey, options);
          setState({
            bt
          });
        } catch (error) {
          setState({
            error: error
          });
        } finally {
          isLoading.current = false;
        }
      }
    })();
  }, [state.bt, apiKey, options, state.error]);
  if (state.bt || state.error) {
    return {
      bt: state.bt,
      error: state.error
    };
  }
  return {
    bt: btFromContext
  };
}